import { action } from 'satcheljs';
export default action('SHOW_IN_IMMERSIVE_READER', function (itemId, actionSource) {
    return {
        itemId: itemId,
        actionSource: actionSource,
    };
});
//# sourceMappingURL=showInImmersiveReader.js.map